// هل تنطبق وحدة الحضور على صاحب الجلسة؟
//
// المسار الوحيد المتاح لأي مستخدم مسجَّل دخوله، ويعيد { enrolled } وحدها بلا أي بيانات حضور.
// المالك وكل الشركاء وكل من لا صفّ له في attendance_enrollment ← enrolled = false، فلا يرى
// التبويب إطلاقًا.
//
// الافتراض مغلق (fail-closed): أثناء التحميل وعند أي فشل تبقى القيمة false، فلا يلمح مستخدمٌ
// تبويبًا ليس له ثم يختفي. والإخفاء ليس آلية الحماية — الخادم يرفض بـ403
// ATTENDANCE_NOT_APPLICABLE على كل مسار — بل هو ألّا نطلب ما ليس من حقّنا.
import { useEffect, useState } from 'react';
import { get } from '../lib/api.ts';

export function useEnrollment(enabled: boolean): { enrolled: boolean; loading: boolean } {
  const [enrolled, setEnrolled] = useState(false);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) { setEnrolled(false); setLoading(false); return; }
    let alive = true;
    setLoading(true);
    void (async () => {
      try {
        const r = await get<{ enrolled: boolean }>('/attendance/enrollment');
        if (alive) setEnrolled(r.enrolled === true);
      } catch {
        if (alive) setEnrolled(false);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [enabled]);

  return { enrolled, loading };
}
